import { httpApi } from '@app/api/http.api';

export const getStats = async () => {
  return httpApi.get('/stats');
};
